// src/pages/AccessibilityStatement.jsx
import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const AccessibilityStatement = () => (
  <Box component="main" sx={{ pt: 32 }} id='top'>
    <Container maxWidth="md">
      <Typography variant="h3" gutterBottom>
        Deklaracja dostępności
      </Typography>
      <Typography paragraph>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus luctus urna sed
        urna ultricies ac tempor dui sagittis. In condimentum facilisis porta. Sed nec
        diam eu diam mattis viverra. Nulla fringilla, orci ac euismod semper, magna
        diam porttitor mauris, quis sollicitudin sapien justo in libero. Vestibulum
        mollis mauris enim. Morbi euismod magna ac lorem rutrum elementum. Donec
        viverra auctor lobortis. Pellentesque eu est a nulla placerat dignissim.
        Morbi a enim in magna semper bibendum. Etiam scelerisque, nunc ac egestas
        consequat, odio nibh euismod nulla, eget auctor orci nibh vel nisi. Aliquam
        erat volutpat. Mauris vel neque sit amet nunc gravida congue sed sit amet
        purus.
      </Typography>
      <Typography paragraph>
        Quisque mollis vestibulum ex, eget tincidunt augue pulvinar vitae. Proin
        rhoncus enim velit, at condimentum orci egestas in. Nullam in velit ante.
        Phasellus in dolor sit amet lectus mattis viverra sit amet quis arcu.
        Praesent porttitor feugiat sem, ut mattis dolor dignissim eu. Pellentesque
        porta purus ex, a condimentum lorem imperdiet in. Aliquam in tortor
        tincidunt, volutpat felis a, vehicula risus. Fusce ornare placerat
        ullamcorper. Aenean porttitor laoreet tincidunt. Nulla facilisi. Ut eget
        purus enim. Donec consectetur, nisl vitae luctus commodo, neque mi dapibus
        libero, eu ultricies urna nisl sed sapien.
      </Typography>
    </Container>
  </Box>
);

export default AccessibilityStatement;
